import React from 'react';
import { phone_number } from '../utils/DictionaryManagementUtils';
import DefaultPanelManuelRecipient from '../components/PanelsComponents/ManuelRecipient/DefaultPanelManuelRecipient';

//= ========================================================================
const Panel_B05_SendMoneyToPhoneManually = ({
  globJSON,
  selectedScreen,
  onConfigChanged,
  onGotoEdit,
  onStepPressed,
  language,
}) => (
  <DefaultPanelManuelRecipient
    globJSON={globJSON}
    selectedScreen={selectedScreen}
    onConfigChanged={onConfigChanged}
    onGotoEdit={onGotoEdit}
    onStepPressed={onStepPressed}
    language={language}
    manualName={phone_number}
    isHollow
  />
);

export default Panel_B05_SendMoneyToPhoneManually;
